import React from "react";

function AboutRightArrow() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 38 61"
    >
      <path
        stroke="#AAEAC8"
        strokeWidth="10"
        d="M4 4l30 30m0-7.071l-30 30"
      />
    </svg>
  );
}

export default AboutRightArrow;
